import { Box, makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../theme/colors";
import { LineChart } from "../charts";
import { GraphFooter } from "../parts";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: 54,
  },
  consumptionBlock: {
    position: "absolute",
    top: "41%",
    left: "-18px",
    transform: "translateY(-50%)",
  },
  consumption: {
    color: COLORS.darks[0][50],
    fontSize: 10,
    transform: "rotate(-90deg)",
  },
  progressBlock: {
    position: "absolute",
    top: -10,
    left: 58,
  },
  progress: {
    height: 184,
    width: 4,
    background:
      "linear-gradient(#E66262 27.77%, #EBC346 57.34%, #45941E 86.91%)",
  },
}));

export const LinearChartPart = ({
  title,
  chartData,
  chartLines,
  graphFooterItems,
  titleStyle,
  showProgress,
}) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  return (
    <Box className={classes.root}>
      <Typography variant="h4" style={titleStyle} className={classes.title}>
        {title}
      </Typography>
      <Box style={{ position: "relative" }}>
        <Box className={classes.consumptionBlock}>
          <Typography className={classes.consumption}>kWh/{user?.unit_system}</Typography>
        </Box>
        {showProgress && (
          <Box className={classes.progressBlock}>
            <Box className={classes.progress}></Box>
          </Box>
        )}
        <LineChart
          chartData={chartData}
          chartLines={chartLines}
          dot={false}
          xAxisPadding={{
            right: 84,
            left: 20,
          }}
          margin={{
            left: 20,
          }}
          hideSum={true}
          toolTipLabel={`Power Consumption (kWh/${user?.unit_system})`}
          unit="nFormatter"
          ticks={[chartData[0].x, chartData[chartData.length - 1].x]}
        />
        <GraphFooter items={graphFooterItems} />
      </Box>
    </Box>
  );
};

LinearChartPart.defaultProps = {
  showProgress: false,
};
